"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_ITEM_TYPES = exports.MediaItemType = void 0;
const utility_1 = require("./utility");
var MediaItemType;
(function (MediaItemType) {
    MediaItemType["Video"] = "video";
    MediaItemType["Image"] = "image";
    MediaItemType["Raw"] = "raw";
})(MediaItemType || (exports.MediaItemType = MediaItemType = {}));
exports.MEDIA_ITEM_TYPES = [
    MediaItemType.Video,
    MediaItemType.Image,
    MediaItemType.Raw,
];
// Test that both MediaItemEnumValues and MediaItemArrayValues match exactly
const _test = utility_1.TestPassValue;
//# sourceMappingURL=MediaItem.js.map